export type BrokerMandateFooterSeparator = 'PIPE' | 'MIDDOT' | 'DASH';

export const FOOTER_SEPARATOR_JOIN: Record<BrokerMandateFooterSeparator, string> = {
  PIPE: ' | ',
  MIDDOT: ' · ',
  DASH: ' — ',
};

export class BrokerMandateFooterModel {
  enabled: boolean;
  company: string | null;
  address: string | null;
  phone: string | null;
  additionalInfo: string | null;
  separator: BrokerMandateFooterSeparator;
}

export class BrokerMandateWatermarkModel {
  enabled: boolean;
  opacity: number;
  grayscale: boolean;
}

export class BrokerMandateDraftModel {
  brokerMandate: string;
  powerOfAttorney: string;
  privacyConsent: string;
  status: BrokerMandateDraftStatusModel;
  footer: BrokerMandateFooterModel;
  watermark: BrokerMandateWatermarkModel;
}

export class BrokerMandateDraftStatusModel {
  draftPresent: boolean;
  publishable: boolean;
  unpublishable: boolean;
}
